import { useTranslation } from "react-i18next"
import { Banner } from "@/components/ui/banner"

export const DeBetterDocNoResultBanner = () => {
  const { t } = useTranslation()

  return (
    <Banner type="inline" variant="critical" data-testid="de-better-doc-no-result-banner">
      {t("episodeOfCare.betterDoc.result.noResult")}
    </Banner>
  )
}
